import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, X } from 'lucide-react';

interface Link {
  label: string;
  url: string;
}

interface LinksListInputProps {
  value?: Link[];
  onChange: (_links: Link[]) => void;
  placeholder?: string;
}

export const LinksListInput: React.FC<LinksListInputProps> = ({
  value = [],
  onChange,
}) => {
  const [links, setLinks] = useState<Link[]>(value);

  useEffect(() => {
    setLinks(value);
  }, [value]);

  const addLink = () => {
    const newLink: Link = { label: '', url: '' };
    const updatedLinks = [...links, newLink];
    setLinks(updatedLinks);
    onChange(updatedLinks);
  };

  const removeLink = (index: number) => {
    const updatedLinks = links.filter((_, i) => i !== index);
    setLinks(updatedLinks);
    onChange(updatedLinks);
  };

  const updateLink = (index: number, field: keyof Link, value: string) => {
    const updatedLinks = links.map((link, i) => 
      i === index ? { ...link, [field]: value } : link
    );
    setLinks(updatedLinks);
    onChange(updatedLinks);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-gray-700">
          Links
        </label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={addLink}
          className="flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Adicionar Link
        </Button>
      </div>
      
      {links.length === 0 ? (
        <div className="text-center py-4 text-gray-500 text-sm border-2 border-dashed border-gray-200 rounded-lg">
          Nenhum link adicionado
        </div>
      ) : (
        <div className="space-y-3">
          {links.map((link, index) => (
            <div key={index} className="flex gap-2 items-start">
              <div className="flex-1 grid grid-cols-2 gap-2">
                <Input
                  placeholder="Label do link"
                  value={link.label}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateLink(index, 'label', e.target.value)}
                />
                <Input
                  placeholder="URL do link"
                  value={link.url}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateLink(index, 'url', e.target.value)}
                />
              </div>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => removeLink(index)}
                className="text-red-500 hover:text-red-700 hover:bg-red-50"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
